import { ModalTypes } from 'enums/modalTypes';
import { closeModal } from 'graphql/modals';
import { Modal, ModalSize } from '@spotted-zebra-uk/ui-components';
import { DeiFieldValue } from './DeiActionForm/dei.helpers';
import DeiActionForm from './DeiActionForm/DeiActionForm';

export interface IEditDeiActionModal {
  projectId: number;
  stageId: string;
  completedCount: number;
  prefilledDeiFields: DeiFieldValue[];
}

const EditDeiActionModal = ({
  projectId,
  stageId,
  completedCount,
  prefilledDeiFields,
}: IEditDeiActionModal) => {
  const handleCloseModal = () => {
    closeModal(ModalTypes.EDIT_DEI_ACTION);
  };

  return (
    <Modal
      onClose={handleCloseModal}
      isOpen
      modalSize={ModalSize.MEDIUM}
      className="edit-dei-action-modal"
      header="Edit Demographic information"
    >
      <DeiActionForm
        stageId={stageId}
        onClose={handleCloseModal}
        type="edit"
        initialValues={{ deiValues: prefilledDeiFields }}
        completedCount={completedCount}
        projectId={projectId}
      />
    </Modal>
  );
};

export default EditDeiActionModal;
